/**
 * @file routes/_app/dispatch/route.tsx
 * @description 派案專區 Layout 路由（M1）。
 *
 * 所有 dispatch/* 子路由的佈局容器。
 * 提供標題列（含返回按鈕）與 <Outlet>。
 */

import { Outlet, createFileRoute } from '@tanstack/react-router';

/** TanStack Router 路由定義 */
export const Route = createFileRoute('/_app/dispatch')({
  component: DispatchLayout,
});

/**
 * 派案專區佈局。
 * 不含額外佈局元素，直接渲染子路由 Outlet。
 */
function DispatchLayout() {
  return <Outlet />;
}
